/*****
 * Vérifier la force et la validité d'un mot de passe
 * 
 * 
 */
let body = document.getElementsByTagName('body')[0]


if (body != null && body != undefined && body.classList.contains('personal-space') || body.classList.contains('page-identification')) {
    
    const prefix = "entities-passchecker";
    const infobox = document.getElementsByClassName(`${prefix}__infobox`)[0]
    let input = document.getElementsByTagName('input')
    const inputs = Array.from(input)

    /*****
     * Animation des champs textes
     */
    if (input != null && input != undefined || inputs != null && inputs != undefined) {
        inputs.forEach(el => {
            el.addEventListener('change', () => {
                if (el.classList.contains('blur')) {
                    return
                } else {
                    el.classList.add('blur')
                }
            }, true)
            if (el.value != "") {
                if (el.classList.contains('blur')) {
                    return
                } else {
                    el.classList.add('blur')
                }
            }
            /***
             * Affiche l'info box si on est dans le champs password
             */
            if (el.classList.contains(`${prefix}__input`) ) {
                let infobox = document.querySelector(`.${prefix}__infobox`)
                // Entrer sur le champ
                el.addEventListener('focus', () => {
                    if (infobox != null && infobox != undefined) {
                        if (infobox.classList.contains('append')) {
                            return
                        } else {
                            infobox.classList.add('append')
                        }
                    }
                }, true)
                // Quitter le champ
                el.addEventListener('blur', () => {
                    if (infobox != null && infobox != undefined) {
                        if (infobox.classList.contains('append')) {
                            infobox.classList.remove('append')
                        } else {
                            return
                        }
                    }
                }, true)
            }
        })
    }
    /***
     * Lance l'événement pour l'infobox
     */
    function updateInfoBox(variation, variationCount, size) {

        // Si le mot de passe contien au moin une majuscule change la class de l'infobox consérnée
        if (variation.upper == true) {
            let upper = document.getElementById(`${prefix}__rule__upper_case`)
           
            if (upper != null && upper != undefined) {
                upper.classList.remove('is-error')
                upper.classList.add('is-valid')
                /* Remplacer l'icone : remplacé par une classe sur l'élément
                if (upper.hasChildNodes()) {
                    upper.children[0].classList.remove('icon-fermer')
                    upper.children[0].classList.add('icon-check')
                }
                */
            }
        }
        // Si le mot de passe contien au moin une minuscule change la class de l'infobox consérnée
        if (variation.lower) {
            let lower = document.getElementById(`${prefix}__rule__lower_case`)
            if (lower != null && lower != undefined) {
                lower.classList.remove('is-error')
                lower.classList.add('is-valid')
            }
        }
        // Si le mot de passe contien au moins un chiffre et un digit change la class de l'infobox concernée
        if (variation.digits == true && variation.nonWords == true) {
            let spechar = document.getElementById(`${prefix}__rule__no_letter`)
            if (spechar != null && spechar != undefined) {
                spechar.classList.remove('is-error')
                spechar.classList.add('is-valid')
            }
        }
        // Si le mot de passe contien des variation chiffre/lettre/digits
        if (variationCount == 3) {
            let moult = document.getElementById(`${prefix}__rule__variation`)
            if (moult != null && moult != undefined) {
                moult.classList.remove('is-error')
                moult.classList.add('is-valid')
            }
        }
        // Si le mot de passe fais au moin 6 chars
        if (size > 5) {
            let numberOf = document.getElementById(`${prefix}__rule__number_of`)
            if (numberOf != null && numberOf != undefined) {
                numberOf.classList.remove('is-error')
                numberOf.classList.add('is-valid')
            }
        }
    }
    /*********************
     * Ajout de la vérification FRONT MDP
     */
    function scorePassword(pass) {
        let score = 0
        if (!pass)
            return score

        // calcul les points force en fonction des répétition de lettre
        let letters = new Object();
        for (let i = 0; i < pass.length; i++) {
            letters[pass[i]] = (letters[pass[i]] || 0) + 1
            score += 5.0 / letters[pass[i]]
        }
        // bonus si on les mélanges
        let variations = {
            digits: /\d/.test(pass),
            /**lower: /[a-z]/.test(pass),*/
            upper: /[A-Z]/.test(pass),
            nonWords: /\W/.test(pass),
        }

        variationCount = 0;
        for (let check in variations) {
            variationCount += (variations[check] == true) ? 2 : 0
        }
        let size = pass.length
        updateInfoBox(variations, variationCount, size)
        score += (variationCount - 1) * 10

        return parseInt(score)
    }

    function checkPassStrength(pass) {
        let score = scorePassword(pass)
        let meter = document.querySelector(`.${prefix}__password-strength-meter`)
        let score_value = document.querySelector(`#${prefix}__score_val`)
        if (score > 80) {
            meter.value = '3'
            score_value.value = score
            return "Mot de passe fort"
        } else if (score > 59) {
            meter.value = '2'
            score_value.value = score
            return "Mot de passe correct"
        } else {
            meter.value = '1'
            score_value.value = score
            return "Mot de passe faible"
        }
    }
    /***
     * Lance l'évent de récupération de mdp
     */
    let inputPass = document.getElementsByClassName('password')
    if (inputPass != null && inputPass != undefined) {
        const passArray = Array.from(inputPass)
        if (passArray != null && passArray != undefined) {
            passArray.forEach(el => {
                el.addEventListener('keyup', () => {
                    let pass = el.value
                        /****
                         * recupère la balise <p> pour afficher le résultat en FRONT
                         * 
                         */
                    let force = document.querySelector(`#${prefix}__strength_human`)
                    if (force != null && force != undefined) {
                        force.innerHTML = checkPassStrength(pass)
                    }
                }, true)
            })
        }
    }
    /**
     * Lance l'événement pour afficher le mdp
     */
    let eyes = document.getElementsByClassName('see_maker')
    if (eyes != null && eyes != undefined) {
        const passEyes = Array.from(eyes)
        if (passEyes != null && passEyes != undefined) {
            passEyes.forEach(el => {
                el.addEventListener('mousedown', () => {
                    if (el.parentElement.getElementsByTagName('input') != null && el.parentElement.getElementsByTagName('input') != undefined) {
                        el.parentElement.getElementsByTagName('input')[0].type = 'text'
                        if (el.parentElement.getElementsByTagName('input')[0].classList.contains('blur')) {
                            return
                        } else {
                            el.parentElement.getElementsByTagName('input')[0].classList.add('blur')
                        }


                    }
                })
                el.addEventListener('mouseup', () => {
                    if (el.parentElement.getElementsByTagName('input') != null && el.parentElement.getElementsByTagName('input') != undefined) {
                        el.parentElement.getElementsByTagName('input')[0].type = 'password'
                        if (el.parentElement.getElementsByTagName('input')[0].classList.contains('blur')) {
                            return
                        } else {
                            el.parentElement.getElementsByTagName('input')[0].classList.add('blur')
                        }

                    }
                })
            })
        }
    }
    /****
     * Bouton Fermer les infos
     */
    let close_btn = document.getElementById(`${prefix}__close-info`)
    if (close_btn != null && close_btn != undefined) {
        close_btn.addEventListener('click', () => {
            if (infobox != null && infobox != undefined) {
                if (infobox.classList.contains('append')) {
                    infobox.classList.remove('append')
                } else {
                    return
                }
            }
        }, true)
    }

}
